export const backgrounds = Object.fromEntries(
  Object.entries(import.meta.glob('./*.{svg,webp}', { eager: true })).map(
    ([k, v]) =>
      [
        k.replace('./', '').replace('.svg', '').replace('.webp', ''),
        (v as { default: string }).default,
      ] as const,
  ),
);
